import React, { useMemo } from "react";
import { Row, Container as BootContainer, Col } from "react-bootstrap";
import { useControl } from "../../controlContext";
import { useControlHeaderContext } from "../../controlWrapperContext";
// import '../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/reportContainers.css'
const container_map = {
  Row,
  Col,
  Container: BootContainer,
  div: 'div'
}

export function Container({ children, displaySettings = {}, idx, name }) {
  const { [idx]: block } = useControl()
  const { as, ...restDisplay } = useMemo(()=>displaySettings, [displaySettings])
  const {settings} = useControlHeaderContext()
  let ContainerType = useMemo(()=> as ? container_map[as] : container_map.Container, [as])
  let clickProps = useMemo(()=>{
    let props = name === 'root' ? settings.rootContainerProps : {}
    // console.log('initalising click in container', name, props)
    return props 
  }, [settings, name])
  // let linkable = useMemo(() => {
  //   let el = document.getElementById(block._id)
  //   if (el) return []
  //   return (
  //     <Row className="g-0" style={{height:0, width:0, overflow:'hidden'}}>
  //       <a id={block._id} href={`#q`} name={block._id} style={{ width: "100%" }}>&nbsp;</a>
  //     </Row>
  //   )
  // },[])
  return (
    <>
      <ContainerType {...restDisplay} {...clickProps}>
        {/*we need this to display or the anchor doesnt work*/}
      <Row className="g-0" style={{height:0, width:0, overflow:'hidden'}}>
        <a id={block._id} href={`#q`} name={block._id} style={{ width: "100%" }}>&nbsp;</a>
      </Row>
        {children}
      </ContainerType>
    </>
  )
}